import { CartItemWidgetRepositionType } from "@swiggy-private/cart-types";

export const VALID_RENDERING_BUTTON_TYPES = {
    COUPON_BUTTON: "APPLY_COUPON_BUTTON",
    COUPON_REMOVE_BUTTON: "COUPON_REMOVE_BUTTON",
    COUPON_DISCOUNT: "COUPON_DISCOUNT",
    ADD_DELIVERY_TIP: "ADD_DELIVERY_TIP",
    SUPER_V3_NUDGE: "SUPER_V3_NUDGE",
    DIRECT_COUPON_WIDGET_APPLY: "DIRECT_COUPON_WIDGET_APPLY",
    OFFER_BUNDLE_BENEFITS: "OFFER_BUNDLE_BENEFITS",
    OFFER_BUNDLE_NUDGE: "OFFER_BUNDLE_NUDGE",
    POSITIVE_DELIVERY_CHARGES: "POSITIVE_DELIVERY_CHARGES",
    POSITIVE_DELIVERY_CHARGES_EXCLUSIVE: "POSITIVE_DELIVERY_CHARGES_EXCLUSIVE",
};

export const CART_ITEM_REWARD_TYPE = {
    FREEBIE: "Freebie",
    SLASH_DEAL: "slashDeals",
};

export const STEAL_DEAL_CART_ITEM_LIST_HEADER_TITLE = "STEAL DEALS";

export const DEAL_RUSH_GROUP_TAG_ID = "DEAL_RUSH";
export const MAGIC_ITEMS_GROUP_TAG_ID = "MAGIC_ITEMS";
export const DEAL_RUSH_KEY = "DEALRUSH";

export const CART_ITEM_GROUP_TYPES = {
    // Custom types (used for rendering super and freebie items)
    SUPER: "super",
    FREEBIE: "freebie",
    // Supported type for Out of Stock
    OUT_OF_STOCK: "outOfStock",
    // Supported types for SILD
    SILD_ELIGIBLE: "sildEligible",
    IN_STOCK_SILD: "inStockSild",
    IN_STOCK_NON_SILD: "inStockNonSild",
    // Supported type for B2G1
    COUPON: "coupon",
};

export const EXPERIMENTS = {
    CART_APPLY_COUPON_POSITION: "cart_apply_coupon_position",
    CART_COUPON_SUGGESTION: "new_apply_coupon_widget_enabled",
    CART_CANCELLATION_POPUP: "cancellation_popup_disable_for_new_users",
    COUPON_LISTING_VERSION: "new_apply_coupon_listing_page_enabled",
    SELECTIVE_COUPON_WIDGET_VARIANT: "selective_coupon_widget_variant",
    CART_FEEDBACK: "cart_abandonment_feedback",
    COUPON_LISTING_MIGRATION_XP: "apply_coupon_webview",
    VALUE_DRIVEN_CROSS_SELL: "value_driven_cross_sell",
    ITEM_IMAGES: "item_image_on_cart",
    CART_V2_XP: "cart_2_0_xp",
    CART_ADDRESS_NUDGE_ENABLED: "cart_address_nudge_enabled",
    POR_FLOW: "por_config_checkout",
    SNACC_STOREFRONT_V2: "is_snacc_storefront_v2",
};

export const EXPERIMENTS_VALUES = {
    CART_APPLY_COUPON_POSITION: {
        FIRST: "first",
        DEFAULT: "default",
    },
    CART_COUPON_SUGGESTION: {
        SHOW: "true",
        HIDE: "false",
    },
    CART_DELIVERY_SPEED: {
        CONTROL: "0",
        TEST1: "1",
        TEST2: "2",
        TEST3: "3",
        TEST4: "4",
    },
};

export const FLOW_TYPE_OFO = "ofo";
export const CART_FEEDBACK_SHOWN = "cart_feedback_shown";
export const CART_FEEDBACK_DEEPLINK = "swiggy://externalWidget?banner_type=WEBVIEW&card_type=HALF_CARD&url={0}";
export const CART_FEEDBACK_URL =
    "https://webviews.swiggy.com/feedback/cart_feedback.html?context=CartFeedback&cart_id={0}";
export const DELIGHT_POPUP_IMPRESSION_FLAG = "delight_popup_impression";
export const DEAL_RUSH_POPUP_IMPRESSION_FLAG = "deal_rush_popup_impression";

export const RECORD_PERCIEVED_TIME_EVENTS = {
    CART_LOAD_EVENT: "blaze_checkout_web_cart_load_time",
    GROUP_CART_LOAD_EVENT: "blaze_checkout_web_group_cart_load_time",
};

export const HTTP_STATUS_CODES = {
    TOO_MANY_REQUESTS: 429,
};

export const ERROR_SCREEN_RETRY_WAIT_TIME_SECS = 60;

export const USER_SPECIFIC_CONFIG = {
    SELECTIVE_COUPON_WIDGET_VARIANT: "selective_coupon_widget_variant",
};

export const OFFER_BUNDLE = {
    PROGRAM: "PLAN_PROGRAM_OFFER_BUNDLE",
    TOOLTIP: "offer_bundle_total",
    TOOLTIP_ARD_KEY: "offer_bundle_info",
};

export const JS_DOWNLOADED_AFTER_INLINE_CALL = "JS_DOWNLOADED_AFTER_INLINE_CALL";

export const REDIRECT_TO_FOODPAGE = {
    REGULAR: "swiggy://restaurantList",
    IRCTC: "swiggyirctc://irctchome?refresh=true",
};

export const PREVIOUS_CART_ID = "previous-cart-id";

export const FLIPKART_INSTALLED_EVENT = "flipkart_installed_event";

export const EMPTY_LOCAL_CART_MESSAGE = "Recieved empty cart data from native";

export enum GRATIFICATION_USECASES {
    BENIFITS = "benefits",
    LM_EXTENSION = "LM_extension",
}

export enum PLAN_ADDITION_SOURCE {
    CART_UPSELL_NUDGE = "cartupsell_nudge",
    ONE_TAP = "one_tap",
    SUBSCRIPTION_RENEWAL_NUDGE = "subscription_renewal_nudge",
}

export const CART_V2_APPLY_COUPON_ICON = "portal/m/apply_coupon_1.png";
export const CART_V2_APPLY_PAYMENT_COUPON_ICON = "portal/m/payment_coupon.png";
export const APPLIED = "Applied";

export const ECO_SAVER_TOAST_FREQUENCY_CAPPING_ID = "eco-saver-toast-frequency-capping-id";

export const OVERLAY_DELAYS = {
    CROUTON: 50,
    HALFCARD_AND_MODAL: 50,
};

export const CROUTON_CLOSE_DELAY = 500; // In ms

export const DEFAULT_CART_ITEM_WIDGET_REPOSITION = [
    {
        type: CartItemWidgetRepositionType.COOKING_INSTRUCTIONS,
        text: "Cooking Instructions",
    },
    {
        type: CartItemWidgetRepositionType.ADD_MORE_ITEMS,
        text: "Add More Items",
    },
];

export const DEAL_RUSH_CROUTON_CLOSED_SID = "deal_rush_crouton_closed_sid";

export const GOT_IT = "Got it";

export const NO_FEE_WEEKEND_POPUP_ACTIONS = {
    DISMISS: "dismiss",
    CLICK_YAY: "Yay",
};

export const NO_FEE_WEEKEND_IMAGE_ID = "NoFeeWeekend/NoFeeWeekend3.png";

export const NO_FEE_WEEKEND_IMAGE_PREFETCH_NR_EVENT = "NO_FEE_WEEKEND_IMAGE_PREFETCH";

export const IMAGE_ASSETS_TO_PREFETCH = [{ cloudinaryId: NO_FEE_WEEKEND_IMAGE_ID, options: {} }];
